import { produce } from "immer";
import {
  GET_RESIDENT_DOCUMENTS,
  GET_RESIDENT_DOCUMENTS_SUCCESS,
  GET_RESIDENT_DOCUMENTS_FAILURE,
  SAVE_RESIDENT_DOCUMENT,
  SAVE_RESIDENT_DOCUMENT_SUCCESS,
  SAVE_RESIDENT_DOCUMENT_FAILURE,
  DELETE_RESIDENT_DOCUMENT,
  DELETE_RESIDENT_DOCUMENT_SUCCESS,
  DELETE_RESIDENT_DOCUMENT_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingDocuments: false,
  documents: { data: [], current_page: 1, last_page: 1 },
  isSubmitting: false,
  isDeleting: false,
};

const ResidentDocumentsReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case GET_RESIDENT_DOCUMENTS:
        draft.isFetchingDocuments = true;
        draft.documents = { data: [], current_page: 1, last_page: 1 };
        break;
      case GET_RESIDENT_DOCUMENTS_SUCCESS: {
        draft.isFetchingDocuments = false;
        const payload = action.payload;
        draft.documents = Array.isArray(payload)
          ? { data: payload, current_page: 1, last_page: 1 }
          : {
              data: payload?.data ?? [],
              current_page: payload?.current_page ?? 1,
              last_page: payload?.last_page ?? 1,
            };
        break;
      }
      case GET_RESIDENT_DOCUMENTS_FAILURE:
        draft.documents = { data: [], current_page: 1, last_page: 1 };
        draft.isFetchingDocuments = false;
        break;
      case SAVE_RESIDENT_DOCUMENT:
        draft.isSubmitting = true;
        break;
      case SAVE_RESIDENT_DOCUMENT_SUCCESS:
      case SAVE_RESIDENT_DOCUMENT_FAILURE:
        draft.isSubmitting = false;
        break;
      case DELETE_RESIDENT_DOCUMENT:
        draft.isDeleting = true;
        break;
      case DELETE_RESIDENT_DOCUMENT_SUCCESS:
      case DELETE_RESIDENT_DOCUMENT_FAILURE:
        draft.isDeleting = false;
        break;

      default:
        return state;
    }
  });

export default ResidentDocumentsReducer;
